import { makeStyles } from '@material-ui/core';

export const useSyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
    },
  },
  buttonAction: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    padding: ' 0 40px',
    // ' & > button': {
    //   visibility: 'hidden',
    // },
  },
  buttonActionActive: {
    // ' & > button': {
    //   visibility: 'visible',
    // },
  },
  invisibleInput: {
    height: '50px',
    width: '530px',
    padding: '16px',
    fontSize: '24px',
    color: '#320066',
    '&::placeholder': {
      color: '#320066',
      textAlign: ' center',
    },
    '&:focus-visible ': {
      outline: 'none',
    },
  },
}));
